<nz-spin [nzSpinning]="loading">
    <p class="m-0"><strong>Dokumenta tips: </strong>{{ entity.documentType?.name }}</p>
    <p class="m-0"><strong>Dokumenta numurs: </strong>{{ entity.number }}</p>

    @if (entity.date) {
        <p class="m-0"><strong>Datums: </strong>{{ entity.date | date: DATE_FORMAT }}</p>
    }

    @if (entity.validUntil) {
        <p class="m-0"><strong>Derīgs līdz: </strong>{{ entity.validUntil | date: DATE_FORMAT }}</p>
    }

    @if (entity.notes) {
        <p class="m-0"><strong>Piezīmes: </strong>{{ entity.notes }}</p>
    }

    @if (entity.ownershipName) {
        <p class="m-0"><strong>Piesaiste: </strong>{{ entity.ownershipName }}</p>
    }

    <nz-collapse [nzBordered]="false">
        <nz-collapse-panel [nzHeader]="'Dokumenta faili'" [nzActive]="true">
            <cl-document-files-table
                [(document)]="entity"
                [documentIsSignable]="entity.isSignable"
                [canEditFields]="false"
                [isEditMode]="false"
            ></cl-document-files-table>
        </nz-collapse-panel>
    </nz-collapse>
    <div *nzModalFooter class="modal-footer">
        <div class="modal-footer-left">
            <cl-info-button [id]="entity.id" [entityType]="EntityType.Document" (loadingChanged)="loading = $event"></cl-info-button>
        </div>
        <div class="modal-footer-right">
            <ng-container>
                <button nz-button nzType="default" (click)="close()">Aizvērt</button>
            </ng-container>
        </div>
    </div>
</nz-spin>
